import { c as _c } from "react/compiler-runtime";
import { cn } from "@repo/ui/lib/utils";
import { Loader2 } from "lucide-react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const sizeClasses = {
  sm: "w-6 h-6",
  md: "w-10 h-10",
  lg: "w-16 h-16"
};
export function SpinnerFullPage(t0) {
  const $ = _c(17);
  const {
    className,
    size: t1,
    message: t2
  } = t0;
  const size = t1 === undefined ? "md" : t1;
  const message = t2 === undefined ? "Loading..." : t2;
  let t3;
  if ($[0] !== className) {
    t3 = cn("bg-background fixed inset-0 flex min-h-screen flex-col items-center justify-center", className);
    $[0] = className;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = sizeClasses[size];
  let t5;
  if ($[2] !== t4) {
    t5 = cn("text-primary animate-spin", t4);
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== t5) {
    t6 = /*#__PURE__*/_jsx(Loader2, {
      className: t5,
      "aria-hidden": "true"
    });
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = /*#__PURE__*/_jsx("span", {
      className: "sr-only",
      children: "Loading"
    });
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== t6) {
    t8 = /*#__PURE__*/_jsxs("div", {
      className: "relative",
      children: [t6, t7]
    });
    $[7] = t6;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== message) {
    t9 = /*#__PURE__*/_jsx("div", {
      className: "text-muted-foreground/80 text-sm font-medium",
      "aria-live": "polite",
      children: message
    });
    $[9] = message;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t8 || $[12] !== t9) {
    t10 = /*#__PURE__*/_jsxs("div", {
      className: "flex flex-col items-center gap-2",
      children: [t8, t9]
    });
    $[11] = t8;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t3) {
    t11 = /*#__PURE__*/_jsx("div", {
      className: t3,
      role: "alert",
      "aria-busy": "true",
      children: t10
    });
    $[14] = t10;
    $[15] = t3;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  return t11;
}